<script setup lang="ts">

import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
import { computed} from "vue";
import ButtomParam from "./ButtonParam.vue"

const props =defineProps<{ title: string ,
 

  type:string
}>()
const $buildingStore = useCalcBuildingStore();
const itemList = computed(()=>{
  return $buildingStore.constants[props.type as keyof typeof $buildingStore.constants]
})






</script>

<template>
 <div ref="moydiv" :class="{'not-first':title!='Ширина пролета, м'}" >
              <span class="group-button-title">{{title}}</span>
            </div>
            <div class="buttongroups-container">

              <template v-for="itemButton in itemList" :key="itemButton.text">
                <ButtomParam :item = itemButton :type="type"/> 
                
              </template>
            </div>
</template>

<style scoped>
.group-button-title{
  font-size: 18px;
  font-weight: 500;
  line-height: 110%;
  letter-spacing: 0%;
}
.buttongroups-container {
  display: flex; 
  flex-wrap: wrap;
  justify-content: flex-start;
  font-size: 16px;
  
  gap: 8px
}
.not-first{
  margin-top: 1rem;
}
</style>
